"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8344],{

/***/ 65179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ card_advantage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 3 modules
var container = __webpack_require__(59203);
// EXTERNAL MODULE: ./components/atoms/next-link/index.ts + 1 modules
var next_link = __webpack_require__(7842);
// EXTERNAL MODULE: ./components/molecules/two-column/index.ts + 2 modules
var two_column = __webpack_require__(55520);
// EXTERNAL MODULE: ./components/molecules/prose/index.ts + 1 modules
var prose = __webpack_require__(60257);
;// CONCATENATED MODULE: ./components/molecules/content-01/Content01.tsx


/**
 * Content01
 */ var Content01 = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, pretitle = param.pretitle, title = param.title, subtitle = param.subtitle, children = param.children, isDark = param.isDark;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-5 ".concat(isDark ? "text-white" : "", " ").concat(className),
        children: [
            pretitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "u-actions u-actions--nav font-semibold italic text-secondary-500",
                children: pretitle
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "u-display u-display--s",
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "u-actions u-actions--nav font-semibold italic text-secondary-500",
                children: subtitle
            }),
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)(prose/* default */.Z, {
                className: "u-body u-body--m text-typo-primary md:u-body--l marker:text-typo-primary prose-strong:font-black prose-strong:text-inherit",
                html: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/molecules/content-01/index.ts

/* harmony default export */ var content_01 = (Content01);

// EXTERNAL MODULE: ./components/molecules/button/index.ts + 1 modules
var molecules_button = __webpack_require__(25634);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(82702);
;// CONCATENATED MODULE: ./components/molecules/card-advantage/CardAdvantage.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                    mt-6 min-w-full md:min-w-fit\n                    ",
        "\n                  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var _altText, _url, ref;
/**
 * CardAdvantage
 */ var CardAdvantage = function(param) {
    var image = param.image, filas = param.filas, imagePositionDesktop = param.imagePositionDesktop, _imagePositionMobile = param.imagePositionMobile, imagePositionMobile = _imagePositionMobile === void 0 ? "top" : _imagePositionMobile, _imageMaxWidth = param.imageMaxWidth, imageMaxWidth = _imageMaxWidth === void 0 ? 350 : _imageMaxWidth, _showImageMobile = param.showImageMobile, showImageMobile = _showImageMobile === void 0 ? true : _showImageMobile, textOrientation = param.textOrientation, _className = param.className, className = _className === void 0 ? "" : _className, _isDark = param.isDark, isDark = _isDark === void 0 ? false : _isDark;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(two_column/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imagePositionDesktop === "right" && {
        reverse: true
    }), {
        gap: "gap-6 md:gap-[94px]",
        className: "items-center !py-9 ".concat(className, "\n    ").concat(showImageMobile ? "min-h-[461px]" : "md:min-h-[461px]", " "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(two_column/* default.Left */.Z.Left, {
                className: "flex flex-wrap max-md:justify-center \n      ".concat(!showImageMobile ? "max-md:hidden" : "", " \n      ").concat(imagePositionMobile === "top" ? "max-md:!order-first" : "", " \n      ").concat(imagePositionDesktop === "left" ? "md:justify-end" : ""),
                children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    src: image.sourceUrl,
                    alt: (_altText = image.altText) !== null && _altText !== void 0 ? _altText : "",
                    width: image.mediaDetails.width,
                    height: image.mediaDetails.height,
                    className: "object-cover"
                }, imageMaxWidth && {
                    style: {
                        width: imageMaxWidth
                    }
                }), {
                    draggable: false
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(two_column/* default.Rigth */.Z.Rigth, {
                className: "".concat(imagePositionDesktop === "right" ? "ml-auto" : "", " max-md:items-center md:max-w-[422px]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                    className: "gap-5",
                    padding: "p-0",
                    children: filas === null || filas === void 0 ? void 0 : filas.map(function(fila, index) {
                        var ref1, ref2, ref3, ref4;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(content_01, {
                                    pretitle: fila.pretitle,
                                    title: fila.title,
                                    subtitle: fila.subtitle,
                                    isDark: isDark,
                                    className: "text-left md:text-".concat(textOrientation),
                                    children: fila.description
                                }),
                                ((ref1 = fila.button) === null || ref1 === void 0 ? void 0 : ref1.label) && ((ref2 = fila.button) === null || ref2 === void 0 ? void 0 : ref2.link) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                    href: (0,utils/* removeBaseURL */.t7)((_url = (ref3 = fila.button) === null || ref3 === void 0 ? void 0 : ref3.link.url) !== null && _url !== void 0 ? _url : ""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, {
                                        label: fila.button.label,
                                        negative: fila.button.negativo,
                                        as: "a",
                                        style: (ref = (ref4 = fila.button) === null || ref4 === void 0 ? void 0 : ref4.style) !== null && ref !== void 0 ? ref : "primary",
                                        className: (0,es/* oneLine */.f9)(_templateObject(), textOrientation === "right" ? "ml-auto" : "mr-auto")
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/molecules/card-advantage/index.ts

/* harmony default export */ var card_advantage = (CardAdvantage);


/***/ }),

/***/ 55520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ two_column; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./lib/utils/collections.tsx
var collections = __webpack_require__(27377);
;// CONCATENATED MODULE: ./components/molecules/two-column/TwoColumn.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        grid grid-cols-1 md:grid-cols-[1fr_1fr]\n        ",
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              ",
        "\n              ",
        "\n            "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              ",
        "\n              ",
        "\n            "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




/**
 * Permite intercambiar las columnas pero este comportamiento solo
 * ocurre en desktop, en mobile la primera columna siempre irá arriba.
 */ var TwoColumn = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _gap = _param.gap, gap = _gap === void 0 ? "" : _gap, _reverse = _param.reverse, reverse = _reverse === void 0 ? false : _reverse, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "gap",
        "reverse",
        "children"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,collections/* pickChild */.xC)(children, two_column.Rigth), 2), Right = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,collections/* pickChild */.xC)(children, two_column.Left), 2), Left = ref1[1];
    var /* TODO: Arreglar tipos */ /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ _className1, /* TODO: Arreglar tipos */ /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ _className2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,es/* oneLine */.f9)(_templateObject(), gap, className)
    }, rest), {
        children: [
            Left && /*#__PURE__*/ (0,jsx_runtime.jsx)(Left.type, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Left.props), {
                className: (0,es/* oneLine */.f9)(_templateObject1(), reverse ? "order-2" : "order-1", (_className1 = Left.props.className) !== null && _className1 !== void 0 ? _className1 : "")
            })),
            Right && /*#__PURE__*/ (0,jsx_runtime.jsx)(Right.type, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Right.props), {
                className: (0,es/* oneLine */.f9)(_templateObject2(), reverse ? "order-1" : "order-2", (_className2 = Right.props.className) !== null && _className2 !== void 0 ? _className2 : "")
            }))
        ]
    }));
};

;// CONCATENATED MODULE: ./components/molecules/two-column/child.tsx

var Column = function(param) {
    var tmp = param.as, HtmlTag = tmp === void 0 ? "div" : tmp, _className = param.className, className = _className === void 0 ? "" : _className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTag, {
        className: "w-full ".concat(className),
        children: children
    });
};

;// CONCATENATED MODULE: ./components/molecules/two-column/index.ts


TwoColumn.Rigth = Column.bind({});
TwoColumn.Left = Column.bind({});
TwoColumn.Rigth.displayName = "TwoColumn.Right";
TwoColumn.Left.displayName = "TwoColumn.Left";
/* harmony default export */ var two_column = (TwoColumn);


/***/ }),

/***/ 66361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ with_paper_border; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 3 modules
var container = __webpack_require__(59203);
;// CONCATENATED MODULE: ./components/molecules/with-paper-border/WithPaperBorder.tsx




var PaperTextureBottom = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7999).then(__webpack_require__.bind(__webpack_require__, 87999)).then(function(mod) {
        return mod.PaperTextureBottom;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87999)
            ];
        }
    },
    ssr: false
});
var PaperTextureTop = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8626).then(__webpack_require__.bind(__webpack_require__, 78626)).then(function(mod) {
        return mod.PaperTextureTop;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78626)
            ];
        }
    },
    ssr: false
});
/**
 * WithPaperBorder
 */ var WithPaperBorder = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _top = param.top, top = _top === void 0 ? false : _top, _bottom = param.bottom, bottom = _bottom === void 0 ? false : _bottom, _border = param.border, border = _border === void 0 ? "inside" : _border, _borderHeight = param.borderHeight, borderHeight = _borderHeight === void 0 ? 12 : _borderHeight, _borderColor = param.borderColor, borderColor = _borderColor === void 0 ? "var(--tw-color-bg-primary)" : _borderColor, id = param.id, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id,
        className: "w-full ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex h-full w-full justify-center overflow-hidden",
            children: [
                top && border === "outside" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaperTextureTop, {
                    className: "absolute -top-px left-0 right-0 z-10 w-full content-['']",
                    height: borderHeight,
                    color: borderColor
                }),
                top && border === "inside" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaperTextureBottom, {
                    className: "absolute -top-px left-0 right-0 z-10 w-full content-['']",
                    height: borderHeight,
                    color: borderColor
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                    as: "div",
                    style: (0,_object_spread/* default */.Z)({
                        padding: 0
                    }, (top || bottom) && {
                        paddingBlock: border === "outside" ? borderHeight - 2 : 0
                    }),
                    className: "w-full",
                    children: children
                }),
                bottom && border === "outside" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaperTextureBottom, {
                    className: "absolute -bottom-px left-0 right-0 z-10 w-full content-['']",
                    height: borderHeight,
                    color: borderColor
                }),
                bottom && border === "inside" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaperTextureTop, {
                    className: "absolute -bottom-px left-0 right-0 z-10 w-full content-['']",
                    height: borderHeight,
                    color: borderColor
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/molecules/with-paper-border/index.ts

/* harmony default export */ var with_paper_border = (WithPaperBorder);


/***/ }),

/***/ 17004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ Positions; }
/* harmony export */ });
var Positions;
(function(Positions) {
    Positions["top"] = "top";
    Positions["bottom"] = "bottom";
    Positions["topBottom"] = "top bottom";
})(Positions || (Positions = {}));


/***/ }),

/***/ 8344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hoc__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70997);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59203);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61150);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66361);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65179);
/* harmony import */ var _molecules_with_paper_border_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17004);
/* harmony import */ var _lib_graphql_transformers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57797);









var ArrowDown = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 1441).then(__webpack_require__.bind(__webpack_require__, 91441)).then(function(m) {
        return m.ArrowDown;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91441)
            ];
        }
    },
    ssr: false
});
var VentajasFlexible = function(param) {
    var bloque = param.bloque, id = param.id;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            bloque.showSeparador && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: "".concat(id, "-separator"),
                align: "items-center",
                justify: "justify-center",
                padding: "p-0",
                className: "hidden md:flex",
                backgroundTop: {
                    backgroundColor: "white"
                },
                backgroundBottom: {
                    backgroundColor: "white"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowDown, {
                    className: "absolute -top-8 z-20 mx-auto mt-3"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_molecules__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                id: id,
                top: bloque.papelRasgado.zona === _molecules_with_paper_border_types__WEBPACK_IMPORTED_MODULE_4__/* .Positions.top */ .v.top || bloque.papelRasgado.zona === _molecules_with_paper_border_types__WEBPACK_IMPORTED_MODULE_4__/* .Positions.topBottom */ .v.topBottom,
                bottom: bloque.papelRasgado.zona === _molecules_with_paper_border_types__WEBPACK_IMPORTED_MODULE_4__/* .Positions.bottom */ .v.bottom || bloque.papelRasgado.zona === _molecules_with_paper_border_types__WEBPACK_IMPORTED_MODULE_4__/* .Positions.topBottom */ .v.topBottom,
                border: bloque.papelRasgado.border,
                borderHeight: bloque.papelRasgado.borderHeight,
                borderColor: bloque.papelRasgado.borderColor,
                children: [
                    (bloque.pretitulo || bloque.titulo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        id: "".concat(id, "-headings"),
                        wrapper: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "my-4 flex w-full flex-col items-center md:mb-4 md:mt-[75px]",
                            children: [
                                bloque.pretitulo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "u-actions--link mb-4 block text-secondary-500",
                                    children: bloque.pretitulo
                                }),
                                bloque.titulo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        bloque.titleSize === "large" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            as: bloque.headingType,
                                            className: "text-center font-primary text-5xl leading-[62px] md:text-8xl md:leading-none",
                                            children: bloque.titulo
                                        }),
                                        bloque.titleSize === "normal" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            as: bloque.headingType,
                                            className: "u-headline u-headline--h1",
                                            children: bloque.titulo
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    bloque.tarjetasVentajas.map(function(item, index) {
                        var advantages = item.tarjetaVentaja;
                        var theNextHasPaperBorder = index < bloque.tarjetasVentajas.length - 1 ? bloque.tarjetasVentajas[index + 1].tarjetaVentaja.papelRasgado.zona !== "none" : false;
                        var hasPaperBorder = advantages.papelRasgado.zona !== "none";
                        var isTheLast = index === bloque.tarjetasVentajas.length - 1;
                        var hasBorder = !theNextHasPaperBorder && !hasPaperBorder && !isTheLast;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hoc__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            condition: hasPaperBorder,
                            wrapper: function(children) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    id: "".concat(id, "-advantages-").concat(index),
                                    top: advantages.papelRasgado.zona === _molecules_with_paper_border_types__WEBPACK_IMPORTED_MODULE_4__/* .Positions.top */ .v.top || advantages.papelRasgado.zona === _molecules_with_paper_border_types__WEBPACK_IMPORTED_MODULE_4__/* .Positions.topBottom */ .v.topBottom,
                                    bottom: advantages.papelRasgado.zona === _molecules_with_paper_border_types__WEBPACK_IMPORTED_MODULE_4__/* .Positions.bottom */ .v.bottom || advantages.papelRasgado.zona === _molecules_with_paper_border_types__WEBPACK_IMPORTED_MODULE_4__/* .Positions.topBottom */ .v.topBottom,
                                    border: advantages.papelRasgado.border,
                                    borderHeight: advantages.papelRasgado.borderHeight,
                                    borderColor: advantages.papelRasgado.borderColor,
                                    children: children
                                });
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, !hasPaperBorder && {
                                id: "".concat(id, "-advantages-").concat(index)
                            }, (0,_lib_graphql_transformers__WEBPACK_IMPORTED_MODULE_9__/* .containerTransformer */ .a)({
                                colorDeFondo: advantages.backgroundColor,
                                imagenBase: advantages.imagenBase,
                                srcset: advantages.srcset
                            })), {
                                wrapper: true,
                                padding: "px-6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    image: advantages.image,
                                    filas: advantages.filas,
                                    imagePositionDesktop: advantages.imagePositionDesktop,
                                    imagePositionMobile: advantages.imagePositionMobile,
                                    imageMaxWidth: advantages.imageMaxWidth,
                                    showImageMobile: advantages.showImageMobile,
                                    textOrientation: advantages.textOrientation,
                                    isDark: advantages.theme === "dark",
                                    className: hasBorder ? "border-b border-dashed border-primary-900" : ""
                                })
                            }))
                        }, index);
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VentajasFlexible);
VentajasFlexible.displayName = "FlexibleVentajas";


/***/ }),

/***/ 57797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ containerTransformer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);

var containerTransformer = function(container) {
    var ref, ref1, ref2, ref3;
    var baseImage = container === null || container === void 0 ? void 0 : (ref = container.imagenBase) === null || ref === void 0 ? void 0 : ref.sourceUrl;
    var ref4;
    var layoutImages = (ref4 = container === null || container === void 0 ? void 0 : (ref1 = container.srcset) === null || ref1 === void 0 ? void 0 : ref1.filter(function(i) {
        return Boolean(i.imagen);
    }).map(function(image) {
        var ref;
        return {
            media: image.anchura,
            src: (ref = image.imagen) === null || ref === void 0 ? void 0 : ref.sourceUrl,
            width: image.imagen.mediaDetails.width,
            height: image.imagen.mediaDetails.height
        };
    })) !== null && ref4 !== void 0 ? ref4 : [];
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (container === null || container === void 0 ? void 0 : container.imagenBase) ? (container === null || container === void 0 ? void 0 : (ref2 = container.imagenBase) === null || ref2 === void 0 ? void 0 : ref2.sourceUrl) ? {
        backgroundImage: {
            src: baseImage,
            srcset: layoutImages,
            alt: container === null || container === void 0 ? void 0 : (ref3 = container.imagenBase) === null || ref3 === void 0 ? void 0 : ref3.altText,
            height: container.imagenBase.mediaDetails.height,
            width: container.imagenBase.mediaDetails.width
        }
    } : {
        backgroundImage: baseImage
    } : {}, (container === null || container === void 0 ? void 0 : container.colorDeFondo) ? {
        style: {
            backgroundColor: container === null || container === void 0 ? void 0 : container.colorDeFondo
        }
    } : {}, (container === null || container === void 0 ? void 0 : container.overlay) ? {
        overlay: (container === null || container === void 0 ? void 0 : container.overlay) / 100
    } : {}, (container === null || container === void 0 ? void 0 : container.justify) ? {
        justify: container === null || container === void 0 ? void 0 : container.justify.reduce(function(previousValue, currentValue) {
            return "".concat(previousValue, " ").concat(currentValue.mediaQuery === "none" ? currentValue.justify : "".concat(currentValue.mediaQuery, ":").concat(currentValue.justify));
        }, "")
    } : {}, (container === null || container === void 0 ? void 0 : container.align) ? {
        align: container === null || container === void 0 ? void 0 : container.align.reduce(function(previousValue, currentValue) {
            return "".concat(previousValue, " ").concat(currentValue.mediaQuery === "none" ? currentValue.align : "".concat(currentValue.mediaQuery, ":").concat(currentValue.align));
        }, "")
    } : {}, (container === null || container === void 0 ? void 0 : container.textAlign) ? {
        textAlign: container === null || container === void 0 ? void 0 : container.textAlign.reduce(function(previousValue, currentValue) {
            return "".concat(previousValue, " ").concat(currentValue.mediaQuery === "none" ? currentValue.textAlign : "".concat(currentValue.mediaQuery, ":").concat(currentValue.textAlign));
        }, "")
    } : {});
};


/***/ })

}]);